<template>
    <div class="container height-100">
        <div class="wrapper">
            <div class="container-small">
                <h3 class="title section-title-26 text-c">
                    {{ $helper.trans('Choose_most_suitable_way_for_you_to_send_package') }}
                </h3>
                <div class="steps-block">
                    <ul class="steps">
                        <li class="active-step">
                            <span class="step-label">{{ $helper.trans('Filling_out_parcel_ticket') }}</span>
                        </li>
                        <li>
                            <span class="step-label">{{ $helper.trans('Order_submission') }}</span>
                        </li>
                        <li>
                            <span class="step-label">{{ $helper.trans('Payment') }}</span>
                        </li>
                    </ul>
                </div>
                <div class="country-selection-block">   
                    <div class="options-navig-block">
                        <div class="options-navig-column selected-country">
                            <input type="text" :value="$store.state.from.countryName" class="input-country input-big" readonly /> 
                            <span class="flag selected-flag" style="top: 30% !important;" :style="{'background-image': 'url(\''+$store.state.from.countryBackgroundImage+'\')'}"></span>
                            <label style="color: #FFF;">{{ $helper.trans('Take_From') }}:</label>
                        </div>
                        <div class="options-navig-column">
                            <input type="text" :value="$store.state.shipperAddressInformation.city" class="input-big" readonly v-if="$helper.needsCity().from"/>
                            <input type="text" :value="$store.state.from.postCode" class="input-big" readonly v-else/>
                        </div>
                    </div>
                    <div class="reverse-block"></div>
                    <div class="options-navig-block">
                        <div class="options-navig-column selected-country">
                            <input type="text" :value="$store.state.to.countryName" class="input-country input-big" readonly />
                            <span class="flag selected-flag" style="top: 30% !important;" :style="{'background-image': 'url(\''+$store.state.to.countryBackgroundImage+'\')'}"></span>
                            <label style="color: #FFF;">{{ $helper.trans('Delivery_to') }}:</label>
                        </div>
                        <div class="options-navig-column">
                            <input type="text" :value="$store.state.deliveryAddressInformation.city" class="input-big" readonly  v-if="$helper.needsCity().to"/>
                            <input type="text" :value="$store.state.to.postCode" class="input-big" readonly v-else/>
                        </div>
                    </div>
                </div>
                <shipping-options-component
                    @optionSelected="selectShippingOption();"
                    :initialSelect="initialSelect"
                />
                <div class="send-block button-block">
                    <button @click="backStep();" class="btn btn-border radius-4">{{ $helper.trans('Back') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import store from "../../../store";
export default {
    store,
    props:{
        initialSelect:{
            type: Boolean,
            required: false,
            default: false,
        }
    },
    methods:{
        selectShippingOption: function(){
            this.$store.state.calculatorState = 'shippingInformationForm';
        },
        backStep: function(){
            this.$store.state.calculatorState = 'initial';
        }
    },
};
</script>